module.exports = __webpack_public_path__ + "img/biz_logo_EN.cb34081b.png";